<template>
    <div>
        <div class="row">
            <div class="col-3">
                <v-alert text class="mb-5">
                    Les formulaires envoyés aux prestataires sont configurables de manière à refléter au plus proche les
                    spécificités de votre territoire. Pour chaque catégorie<span
                        v-if="account.tis_type.code === 'APIDAE'"> de
                        fiche Apidae</span>,
                    vous pouvez définir l'ensemble de critères affichés dans les formulaires.<br />
                </v-alert>

                <v-alert type="info" text class="mb-5">
                    Par défaut, tous les critères sont actifs.
                </v-alert>
            </div>
            <div class="col">
                <v-card class="p-4">
                    <div class="mb-5">
                        <v-btn outlined class="custom-button-primary" @click="save">
                            <v-icon left>save</v-icon> Enregistrer
                        </v-btn>
                    </div>

                    <div class="row">
                        <div class="col-6">
                            <v-select :items="categories" outlined :value="currentCategory" item-text="label"
                                return-object @change="selectCategory" label="Catégorie">
                            </v-select>
                        </div>
                        <div class="col-6" v-show="loaded">
                            <v-text-field background-color="white" append-icon="mdi-magnify" label="Rechercher un champ"
                                v-model="search" clearable outlined>
                            </v-text-field>
                        </div>
                    </div>

                    <div v-if="!loaded" class="text-center">
                        <v-progress-circular class="progressbar" indeterminate size="40" width="4">
                        </v-progress-circular>
                        <div class="text-center mt-3" style="color: gray">
                            Récupération du référentiel en cours
                        </div>
                    </div>
                    <div v-show="loaded">
                        <v-treeview selectable selected-color="primary" item-key="_id" rounded return-object
                            v-model="selectedItems" :open-on-click="true" :search="search" :items="referential">
                        </v-treeview>
                    </div>
                </v-card>

            </div>
        </div>

    </div>
</template>

<script>
import { mapState } from "vuex"

export default {
    name: "Referential",
    data() {
        return {
            search: null,
            referential: [],
            loaded: false,
            selectedItems: [],
            currentCategory: null,
            index: 1,
            categories: [],
            currentRef: []
        }
    },
    methods: {
        removeCategoriesCheckBoxes() {
            let treeView = document.querySelector('.v-treeview')

            if (treeView !== null) {
                let categories = treeView.querySelectorAll(':scope > div')

                categories.forEach(category => {
                    let button = category.querySelectorAll('button')[1]

                    if (button) {
                        button.remove()
                    }
                })
            }
        },
        loadReferential() {
            this.loaded = false
            this.referential = []

            this.$http.get('auth/account/referential/' + this.currentCategory.id).then(res => {
                this.referential = res.body.data.referential
                this.currentRef = res.body.data.current_referentials.map(item => item = item.id)
                this.selectedItems = []

                this.selectElements()

                setTimeout(() => {
                    this.removeCategoriesCheckBoxes()
                    this.loaded = true
                }, 1000)
            })
        },
        getSelectedElements() {
            let elements = this.selectedItems.filter(element => element.model === 'App\\Models\\Referential\\Element')

            return elements.map(elt => elt.id)
        },
        selectElements() {
            this.deepReduce(this.referential)
        },
        hasChildren(node) {
            return (typeof node === 'object')
                && (typeof node.children !== 'undefined')
                && (node.children.length > 0)
        },
        deepReduce(array) {
            return array.reduce((acc, val) => {
                let endValue = this.hasChildren(val) ? this.deepReduce(val.children, acc) : val

                if (endValue.model === "App\\Models\\Referential\\Element" && this.currentRef.includes(endValue.id)) {
                    this.selectedItems.push(endValue)
                }

                return acc.concat(endValue)
            }, [])
        },
        async save() {
            let elements = this.getSelectedElements()

            let payload = {
                categoryId: this.currentCategory.id,
                elements: elements
            }

            this.$global.loading = true

            await this.$http.post('auth/account/referential', payload)
            this.$global.loading = false
        },
        async selectCategory(value) {
            if (this.loaded) {
                await this.save(false)
            }

            this.currentCategory = value

            this.loadReferential()
        },
        getCategories() {
            this.$http.get('resource/categories').then(res => {
                this.categories = res.body.data.categories

                this.selectCategory(this.categories[0])
            })
        }
    },
    computed: {
        ...mapState('account', ['account'])
    },
    created() {
        this.getCategories()
    }
}
</script>
